import {
  ConciliacionesConciliacionBancaria,
  Spinner,
} from "@finanedi.es/front-ops"
import { PropuestasConciliacionHeader } from "feature-based/features/conciliaciones/atoms"
import { usePropuestasConciliacionPage } from "./hooks"

export const PropuestasConciliacionPage = () => {
  const { cuentaId, handleConciliar, ibanCuenta, nifTitular } =
    usePropuestasConciliacionPage()

  if (!cuentaId) return <Spinner />
  return (
    <div className='tw-flex tw-flex-col tw-h-full tw-min-h-0'>
      <PropuestasConciliacionHeader cuentaId={cuentaId} />
      <ConciliacionesConciliacionBancaria
        cuenta={{ nif: nifTitular, iban: ibanCuenta }}
        conciliarMethod={handleConciliar}
      />
    </div>
  )
}
